import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyD2-3Mz6Xut3TKMPUJiXZDFqB-fhgRCs6M",
    authDomain: "innovorder-poc.firebaseapp.com",
    databaseURL: "https://innovorder-poc-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "innovorder-poc",
    storageBucket: "innovorder-poc.appspot.com",
    messagingSenderId: "261036568599",
    appId: "1:261036568599:web:7814fcc51eaa360bceac52",
    measurementId: "G-K3JLCNHCGP"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore();